import { getUser } from '../AppServices';
import { MODELS } from '../Lib/constants';
import { getUserRole } from '../Lib/helpers';

export const allDetailsListSidebarUri = ({
  filter = {},
  params,
  navigation,
} = {}) => {
  const user = getUser();
  let addOnFilter = {};

  const userRole = getUserRole();

  if (userRole === 'superadmin' || userRole === 'admin') {
    if (navigation?.state?.params?.item?.username) {
      addOnFilter = { dealerName: navigation?.state?.params?.item?.username };
    }
  } else if (userRole === 'dealer') {
    addOnFilter = { dealerName: user?.username };
  }

  return {
    query: {
      id: 'allDetailsList',
      addOnFilter,
    },
    aggregate: true,
    model: MODELS.UCIReport,
  };
};

export const showAllDetailsUri = ({ navigation }) => {
  return {
    query: {
      model: MODELS.UsedCarInventory,
      id: 'showAllDetails',
      relationValue: {
        model: MODELS.UCIReport,
        _id: navigation?.state?.params?.item?._id,
        relation: '_id',
      },
      limit: 1,
    },
    model: MODELS.UCIReport,
  };
};
